"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignature = void 0;
const fs_1 = require("fs");
const dubhash_1 = require("./dubhash");
const { readFile } = fs_1.promises;
async function getSignature(filePath) {
    try {
        const fileContents = await readFile(filePath);
        if (fileContents.length === 0)
            return null;
        return dubhash_1.getDubHashSignature(filePath, fileContents);
    }
    catch (err) {
        console.error(err);
        throw err;
    }
}
exports.getSignature = getSignature;
//# sourceMappingURL=signatures.js.map